import { Observable } from 'rxjs';
import { UseCase } from '../../base/use-case';

import { ConfigurationRepository } from '../../repositories/configuration.repository';
import { DataScheduleProfessionalModel, ScheduleProfessionalModel } from '../../models/configuration/schedule-professional.model';

export class InsertScheduleProfessionalUseCase
	implements UseCase<DataScheduleProfessionalModel[], ScheduleProfessionalModel>
{
	constructor(private configurationRepository: ConfigurationRepository) {}

	execute(params: DataScheduleProfessionalModel[]): Observable<ScheduleProfessionalModel> {
		return this.configurationRepository.insertScheduleProfessional(params);
	}
}